<template>
  <div>
    <el-table
      ref="multipleTable"
      :data="tableData"
      style="width: 100%"
      border
      stripe
    >
      <el-table-column
        label="商品名"
        align="center"
        prop="commodityName"
        min-width="200"
      />
      <el-table-column
        label="签收时间"
        align="center"
        prop="updateTime"
        width="160"
      />
      <el-table-column
        label="数量"
        align="center"
        prop="quantity"
        width="100"
      />
      <el-table-column
        label="商品封面"
        align="center"
        prop="address"
        width="120"
      >
        <template slot-scope="{ row }">
          <el-image
            style="width: 60px; height: 60px"
            :src="row.cover"
            :preview-src-list="[row.cover]"
          ></el-image>
        </template>
      </el-table-column>

      <el-table-column
        label="商品规格"
        align="center"
        prop="commoditSpecifications"
        width="160"
      >
      </el-table-column>
      <el-table-column
        label="仓库"
        align="center"
        prop="targetEntrepotName"
        width="240"
      >
        <template slot-scope="{ row }">
          发货仓库：{{ row.sourceEntrepotName }}
          <br />
          接收仓库：{{ row.targetEntrepotName }}
        </template>
      </el-table-column>
      <el-table-column label="备注" align="center" prop="remark" width="240" />
      <el-table-column
        label="创建时间"
        align="center"
        prop="createTime"
        width="160"
      >
      </el-table-column>
      <el-table-column
        label="操作"
        align="center"
        prop="icon"
        fixed="right"
        width="140"
      >
        <template slot-scope="scope">
          <el-button
            type="primary"
            plain
            @click="UpdateButton(scope.row)"
            v-if="
              hasAuth('sys:entrepot:edit') &&
              scope.row.type == 2 &&
              scope.row.state == 0
            "
            >签收</el-button
          >
        </template>
      </el-table-column>
    </el-table>
    <el-pagination
      :current-page="searchForm.pageNo"
      :page-size="searchForm.pageSize"
      :page-sizes="[10, 20, 50, 100]"
      :total="total"
      layout="total, sizes, prev, pager, next, jumper"
      @size-change="handleSizeChange"
      @current-change="handleCurrentChange"
    >
    </el-pagination>
  </div>
</template>
<script>
export default {
  components: {},
  data() {
    return {
      tableData: [],
      total: 0,
      searchForm: {
        pageNo: 1,
        pageSize: 10,
        sourceEntrepotId: null,
        targetEntrepotId: null,
      },
    };
  },
  created() {
    this.getList();
  },
  methods: {
    handleSizeChange(val) {
      this.searchForm.pageSize = val;
      this.getList();
    },
    handleCurrentChange(val) {
      this.searchForm.pageNo = val;
      this.getList();
    },
    UpdateButton(row) {
      this.$confirm("确认签收?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          this.$axios
            .post("/admin/entrepotAllotRecord/confirmReceiptOfGoods", {
              id: row.id,
            })
            .then((res) => {
              this.$message({
                showClose: true,
                message: "签收成功",
                type: "success",
                onClose: () => {},
              });
              this.getList();
            });
        })
        .catch(() => {});
    },
    getList() {
      this.$axios
        .get(
          "/admin/entrepotAllotRecord/getEntrepotAllotRecordList?pageNo=" +
            this.searchForm.pageNo +
            "&pageSize=" +
            this.searchForm.pageSize
        )
        .then((res) => {
          this.tableData = res.data.records;
          this.total = res.data.total;
        });
    },
  },
};
</script>

<style scoped>
.el-button {
  padding: 0 10px;
  height: 35px;
  line-height: 35px;
  font-size: 15px;
  margin-right: 10px;
}
.cus_area {
  margin: 10px;
}
</style>
